import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider as ToastPrimitivesProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/Toast'
import { useToast } from '@/hooks/useToast'

export const ToasterProvider = () => {
  const { toasts } = useToast()

  return (
    <ToastPrimitivesProvider>
      {toasts.map(({ id, title, description, action, ...props }) => (
        <Toast key={id} {...props}>
          <div className="grid gap-1">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription>{description}</ToastDescription>}
          </div>
          {action}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastPrimitivesProvider>
  )
}
